export default __webpack_public_path__ + "static/media/40236.cea1bece.jpg";